export default {
  statistics: {
    total_followers: 'Følgere i alt',
    emails_sent: 'Sendte e-mails',
    emails_opened: 'Åbnede e-mails',
    emails_clicked: 'Klikkede e-mails',
    emails_average_open_rate: 'Åbningsrate for e-mails',
    emails_average_click_rate: 'Klikrate for e-mails',
    push_notifications_sent: 'Sendte push-notifikationer',
    push_notifications_clicked: 'Klikkede push-notifikationer',
  },
};
